import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function FocusedAtMidLine(_ref) {
  var atMidLineClassName = _ref.atMidLineClassName,
    _ref$rootMargin = _ref.rootMargin,
    rootMargin = _ref$rootMargin === void 0 ? '-45% 0% -45% 0%' : _ref$rootMargin,
    children = _ref.children;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isAtMidLine = _useState2[0],
    setIsAtMidLine = _useState2[1];
  var domRef = useRef(null);
  useEffect(function () {
    var observedElement = domRef.current;
    var config = {
      rootMargin: rootMargin,
      threshold: 0
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        return setIsAtMidLine(entry.isIntersecting);
      });
    }, config);
    observer.observe(observedElement);

    // clean up
    return function () {
      return observer.unobserve(observedElement);
    };
  }, [rootMargin]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames({
      [atMidLineClassName]: isAtMidLine
    }),
    ref: domRef,
    children: children
  });
}